// src/components/Blogpage/BlogList.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import thumbnails from "./assets/blog-thumbnail.png";
import { fetchBlogs } from '../../services/api';

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getBlogs = async () => {
      try {
        const blogData = await fetchBlogs();
        setBlogs(blogData);
      } catch (err) {
        setError('Failed to load blogs');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    getBlogs();
  }, []);

  if (loading) {
    return (
      <section className="px-6 md:px-16 py-20 text-white min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-blue-900 text-xl">Loading blogs...</p>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="px-6 md:px-16 py-20 text-white min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 text-5xl mb-4">⚠️</div>
          <p className="text-red-500 text-xl">{error}</p>
          <button 
            className="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>
      </section>
    );
  }

  return (
    <section
      className="px-6 md:px-16 py-20 text-white space-y-32"
      style={{
        background: "linear-gradient(to bottom, #fff 0%, #ebebeb 16.6%, #fff 33.2%, #ebebeb 49.8%, #fff 66.4%, #ebebeb 83%, #eee 100%)"
      }}
    >
      <div className="container mx-auto px-4">
        {blogs.length === 0 ? (
          <div className="text-center py-20">
            <h2 className="text-blue-900 text-2xl">No blogs found</h2>
            <p className="text-gray-600 mt-2">Check back later for new content!</p>
          </div>
        ) : (
          blogs.map((blog, index) => (
            <div
              key={blog._id}
              id={`blog-${blog._id}`}
              className="border border-blue-300 rounded-[50px] overflow-hidden mb-8 flex flex-col md:flex-row transition-all duration-500 transform"
              style={{
                animation: `dropIn ${0.2 * (index + 1)}s ease-out forwards`,
                opacity: 0,
              }}
            >
              <style>{`
                @keyframes dropIn {
                  from { transform: translateY(-50px); opacity: 0; }
                  to { transform: translateY(0); opacity: 1; }
                }
              `}</style>
              <div className="md:w-1/5">
                {/* Use actual thumbnail from API if available */}
                <img 
                  src={blog.thumbnail || thumbnails} 
                  alt={blog.title} 
                  className="w-full h-full object-cover p-3 rounded-[50px]" 
                />
              </div>
              <div className="md:w-4/5 p-4">
                <h2 className="text-blue-900 font-bold text-4xl mb-2">{blog.title}</h2>
                <p className="text-black text-lg mb-4">{blog.shortDescription}</p>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-xs">{blog.date}</span>
                  <Link 
                    to={`/blogs/${blog._id}`}
                    className="text-blue-500 hover:underline text-xs flex items-center"
                  >
                    Learn More <span className="ml-1">→</span>
                  </Link>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </section>
  );
};

export default BlogList;